<template>
  <div class="options-row row BoxStyle" :class="[{'RemoveControl':clicked!==-1}]">
    <div class="col-12 text-center HeaderPositionQuestion">
      <h1 id="questionTitle" class="redText main-title" :class="['fade', {'fade-in':question}]">
        Find the character for ‘nine’
        <img
          class="x-btn"
          style="cursor: pointer;float: right"
          @mouseenter="buttonHover"
          :src="require(`@/assets/img/Question.png`)"
          alt
          @click="closeClick"
        />
      </h1>
    </div>
    <div
      class="col-4 mx-2 mt-3 fade options image"
      style="transition: all 0.6s ease!important;"
      v-for="(i, index) in list"
      :key="i"
      :style="{border:clicked !== -1 || ShowMe?'unset':''}"
      :class="[{'fade-in':images,'active': active === i,
                                'RemoveAnimation':clicked !== -1 &&  clicked !== index ,
                  'clicked hinted': clicked === index && ShowMe!== true,
                  'move-right': ( ( (clicked===2 && index===1) || (clicked===1 && index===2 ) || (clicked===0 && index===2 ) ) && ShowMe!== true ),
                  'move-left': ( ( (clicked===2 && index===0) || (clicked===1 && index===0 ) || (clicked===0 && index===1 ) ) && ShowMe!== true),
                  },
                   `index-${list.length===1?1:index}`,
                    `${ControlToShow(index)}`,
                   `l2q8option-${i}`]"
    >
      <template v-if="index===1">
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-else>
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-if="i===2">
        <img
          src="../../../assets/img/sign.gif"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            position:'absolute',
            left: '-23%',
            top: '15%',
            width: '26%',
            height: '60%',
            zIndex: '99'
          }"
        />
      </template>

      <template v-if="i===3">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '-24%',
            top: '1%',

          }"
        ></div>
      </template>
      <template v-if="i===2 && pregress">
        <div class="fork fork1">
          <div class="fork2" />
          <div class="height" />
          <div class="width" />

          <div class="fork4" />
        </div>
        <!-- <div class="fork fork2" /> -->
        <img alt="dash.png" src="./images/left-grey.png" class="fork fork3" />
      </template>
      <template v-if="i===3 && pregress">
        <img alt="dash.png" src="./images/3-center.svg" class="part part1" />
        <img alt="dash.png" src="./images/3-top.png" class="part part2" />
        <img alt="dash.png" src="./images/3-left.png" class="part part3" />
      </template>
    </div>

    <div
      style="bottom: 10px;position: absolute;padding: 10px "
      :class="{'fade hints-row': true, 'fade-in':textBoxEnable===1, 'fade-out':textBoxEnable===2 }"
    >
      <div
        class="col-12 p-0"
        v-for="(i) in list"
        :key="i"
        :class="[{'active': active === i, }]"
        style="padding: 0"
      >
        <div v-if="textBox[i] !== ''" class="pt-5">
          <div class="pt-5 mt-4">
            <div v-if="textBox[i] !== ''" class="text-box py-3 px-3 align-center text-center">
              <p class="mb-0 mr-3">{{textBox[i]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question8",

  data() {
    return {
      pregress: false,
      wrongShow: false,
      ShowMe: false,
      textBoxEnable: 0,
      closeTextEnable: false,
      images: false,
      question: false,
      active: 0,
      clicked: -1,
      list: [1, 2, 3],
      textBox: {
        1: "",
        2: "",
        3: ""
      },
      hints: {
        1: "",
        2: `Good job that you’ve noticed the essential part of the character. This is a special stroke in Chinese. However, you’ll need something more on the left.`,
        3: `When we look at the joints of strokes in a character, it is vital that we check whether the strokes stick out or not.`
      },
      hinted: false,
      mouse_over: "/sound/new mouse over.wav"
    };
  },
  props: {
    playSound: {
      type: Function
    },
    shuffle: {
      type: Function
    },
    finish: {
      type: Function
    },
    buttonHover: {
      type: Function
    }
  },
  mounted() {
    this.images = false;
    this.list = this.shuffle(this.list);

    this.playSound(require("./sounds/2-8.wav"));
    setTimeout(() => {
      this.question = true;

      setTimeout(() => {
        this.images = true;
      }, 2000);
      setTimeout(() => {
        this.closeTextEnable = true;
        // this.playSound("/sound/textbox shows.wav");
        setTimeout(() => {
          this.closeTextEnable = false;
        }, 5000);
      }, 3000);
    }, 500);
  },
  methods: {
    closeClick() {
      if (this.ShowMe === true || this.pregress === true) {
        return;
      }
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.pregress = true;
      this.ShowMe = false;
      this.playSound("/sound/button click.wav").then(() => {
        setTimeout(() => {
          this.textBox = {
            1: "",
            2: "",
            3: ""
          };

          setTimeout(() => {
            this.clicked = this.list.indexOf(2);

            setTimeout(() => {
              this.wrongShow = true;
            }, 1300);
            this.textBox[2] = JSON.parse(JSON.stringify(this.hints[2]));
            this.hinted = true;
            this.playSound("/sound/textbox shows.wav");
            this.playSound(require("./sounds/2-82.wav")).then(() => {
              const forks = document.getElementsByClassName("fork");

              setTimeout(() => {
                forks.forEach(fork => {
                  console.log(fork);

                  fork.classList.toggle("part");
                });
              }, 3000);
              this.wrongShow = false;
              setTimeout(() => {
                this.wrongShow = true;
              }, 400);
              setTimeout(() => {
                this.playSound("/sound/textbox shows.wav");
                this.list = [1, 3, 2];
                this.clicked = this.list.indexOf(3);

                this.textBox[2] = "";
                this.textBox[3] = JSON.parse(JSON.stringify(this.hints[3]));
                forks.forEach(fork => {
                  console.log(fork);

                  fork.classList.remove("part");
                });
                this.playSound(require("./sounds/2-83.wav")).then(() => {
                  setTimeout(() => {
                    this.wrongShow = false;
                    this.playSound("/sound/correct answer.wav");
                    this.textBox = {
                      1: "",
                      2: "",
                      3: ""
                    };
                    this.list = [3, 1, 2];
                    this.clicked = this.list.indexOf(1);

                    setTimeout(() => {
                      this.hinted = false;
                      // this.start = false
                      // this.end = false
                      this.textBoxEnable = 0;
                      this.list = this.shuffle(this.list);
                      this.pregress = false;
                      this.active = 0;
                      this.ShowMe = false;
                      this.clicked = -1;
                    }, 3000);
                  }, 8000);
                });
              }, 6000);
            });

            this.textBoxEnable = 1;
          }, 50);
        });
      }, 1000);
    },
    mouseleave() {
      this.active = 0;
    },
    mouseover(i) {
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.active = i;
      this.playSound(this.mouse_over);
    },
    ControlToShow(i) {
      if (this.ShowMe) {
        if (i === 0) {
          return "RemoveAnimation";
        }
        if (i === 2) {
          return "RemoveAnimation";
        }
      } else {
        return "Scale1";
      }
      return "";
    },
    closeTextBox() {
      this.textBoxEnable = 2;
      this.hinted = false;
      setTimeout(() => {
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.textBoxEnable = 0;
        this.clicked = -1;
      }, 1000);
    },
    imgClick(i, index) {
      if (this.clicked !== -1 || this.ShowMe || this.pregress === true) {
        return;
      }
      this.pregress = true;

      setTimeout(() => {
        this.hinted = false;
        this.clicked = index;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        if (i === 1) {
          setTimeout(() => {
            this.pregress = false;
            this.closeTextBox();
          }, 3000);
          this.playSound("/sound/correct answer.wav");
          this.finish();
        } else {
          setTimeout(() => {
            this.wrongShow = true;
          }, 1900);

          setTimeout(() => {
            this.wrongShow = false;
          }, 6000);
          this.playSound("/sound/highlight.wav");

          this.clicked = index;
          if (i === 2) {
            this.textBox[i] = this.hints[i];
            this.playSound(require("./sounds/2-82.wav")).then(() => {
              const forks = document.getElementsByClassName("fork");
              setTimeout(() => {
                forks.forEach(fork => {
                  console.log(fork);

                  fork.classList.toggle("part");
                });
              }, 3000);
              setTimeout(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                this.pregress = false;
                forks.forEach(fork => {
                  console.log(fork);

                  fork.classList.remove("part");
                });
              }, 6500);
            });
          } else {
            this.textBox[i] = this.hints[i];
            this.playSound(require("./sounds/2-83.wav")).then(() => {
              setTimeout(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                this.pregress = false;
              }, 7500);
            });
          }
          setTimeout(() => {
            this.playSound("/sound/textbox shows.wav");
            this.textBoxEnable = 1;
          }, 1000);
          setTimeout(() => {}, 1000);
          if (index != 1) {
            console.log(index);
          }
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.l2q8option-2 {
  .fork {
    position: absolute;
    top: 14%;
    left: 70%;
    height: 72%;
    width: 52%;
    opacity: 0;
  }

  .fork1 {
    background-color: #000000;
    mask: url("./images/2.png");
    mask-size: cover;
    mask-repeat: no-repeat;
    height: 70%;
    width: 189px;
  }
  .fork4 {
    position: absolute;
    bottom: 20px;
    width: 100%;
    left: 30px;
    height: 0;
    transform: rotate(45deg);
    background-color: #c4c4c4;
  }
  .height {
    width: 140px;
    transition:all 2s linear;
    background-color: #c4c4c4;
    height: 0;
    position: absolute;
    top: 10px;
  }

  // .width {
  //   // bottom: 20%;
  //   // left: 140px;
  //   width: 0;
  //   height: 100%;
  //   transition:all 2s linear;
  //   background-color: #c4c4c4;
  // }
  .fork2 {
    background-color: #c4c4c4;

    height: 36%;
    opacity: 1;
    transition: all 1s;

    width: 0%;
  }

  .v-image {
    left: 0;

    /*opacity: 0;*/
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;

      /*opacity: 0;*/
    }

    .fork {
      transition: all 2s linear;
      transition-delay: 4s;
      opacity: 1;
    }

    .fork1 {
      opacity: 1;
    }

    .fork3 {
      transition-delay: 9.2s;
    }
    .fork2 {
      width: 140px;
      transition-delay: 6s;
    }

    .height {
      transition-delay: 6.5s;
      height: 100%;
      animation: width-the-grey 1s 8.2s forwards;
    }

    .fork4 {
      transition:all 2s linear;
      transition-delay: 8.2s;
      height: 60%;
    }
    .part {
      transition-delay: 0s;
      opacity: 0 !important;
    }
  }
}

@keyframes width-the-grey {
  100% {
    width: 165px;
  }
}

@keyframes height-the-grey {
  50% {
    height: 100%;
  }
  100% {
    height: 100%;
    width: 160px;
  }
}

@keyframes fill-with-grey {
  100% {
    width: 140px;
  }
  // }
  // 70% {
  //   width: 150px;
  //   height: 90%;
  // }
  // 90% {
  //   width: 170px;
  //   height: 100%;
  // }
  // 100% {
  //   width: 189px;
  //   height: 100%;
  // }
}

.l2q8option-3 {
  .part {
    position: absolute;
    top: 0%;
    left: 70%;
    width: 60%;
    opacity: 0;
    transition: all 2s;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }
  .part2 {
    height: 0%;
    top: 23%;
  }

  .part3 {
    width: 0%;
    height: 84%;
    left: 90%;
  }
  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }

    .part {
      animation: fadeIn 1s 3s forwards;
      transition: all 2s;
    }

    .part2 {
      animation: stiksNineTop 6s 6s forwards, fadeIn 1s 3s forwards;
    }

    .part3 {
      animation: stiksNineRight 6s 5s forwards, fadeIn 1s 3s forwards;
    }
  }
}

@keyframes stiksNineTop {
  20% {
    height: 160%;
    top: -18%;
  }
  80% {
    height: 160%;
    top: -18%;
  }
}

@keyframes stiksNineRight {
  20% {
    left: 50%;
    width: 140%;
  }
  80% {
    left: 50%;
    width: 140%;
  }
}
</style>